/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (id = null) => {
	return {
		type: actions.RESET_DASHBOARD_LAYOUT,
		payload: {
			id,
		},
	};
};
